import { Button, ButtonProps } from '@mui/material';
import { ReactElement } from 'react';

import CancelButton from '@/components/atoms/CancelButton';
import useConfirmDialog from '@/components/organisms/confirmDialog/useConfirmDialog';
import ChatThemeProvider from '@/providers/ChatThemeProvider';

const useConfirmContinueDialog = (disableRestoreFocus?: boolean) => {
  // Dialogが開くときにスクロールの挙動が意図しない動きをするときはdisableRestoreFocus=trueに
  const confirmDialog = useConfirmDialog(false);
  return {
    open: (props: {
      message?: string;
      content?: ReactElement;
      title: string;
      okLabel?: string;
      okColor?: ButtonProps['color'];
    }) =>
      confirmDialog.open(
        {
          title: props.title,
          message: props.message,
          content: props.content,
          actions: [
            <CancelButton
              key="cancal"
              onClick={() => confirmDialog.close(false)}
            />,
            <Button
              key="ok"
              onClick={() => confirmDialog.close(true)}
              color={props.okColor ?? 'primary'}
            >
              {props.okLabel ?? 'OK'}
            </Button>,
          ],
          disableRestoreFocus: disableRestoreFocus ?? false,
        },
        (c) => <ChatThemeProvider>{c}</ChatThemeProvider>
      ),
  };
};
export default useConfirmContinueDialog;
